import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "33",
  height: "33",
  viewBox: "0 0 33 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 4C0 1.79086 1.79086 0 4 0H29C31.2091 0 33 1.79086 33 4V29C33 31.2091 31.2091 33 29 33H4C1.79086 33 0 31.2091 0 29V4Z",
  fill: "#F8F9FA"
}, null, -1)
const _hoisted_3 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BtnRightIcon',
  props: {
    color: null
  },
  setup(__props: any) {

const props = __props as { color?: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("path", {
      d: "M14.3131 22.0202C14.1356 21.8427 14.1195 21.5649 14.2647 21.3692L14.3131 21.3131L18.626 17L14.3131 12.6869C14.1356 12.5094 14.1195 12.2316 14.2647 12.0359L14.3131 11.9798C14.4906 11.8023 14.7684 11.7861 14.9641 11.9314L15.0202 11.9798L19.6869 16.6464C19.8644 16.824 19.8805 17.1017 19.7353 17.2975L19.6869 17.3536L15.0202 22.0202C14.825 22.2155 14.5084 22.2155 14.3131 22.0202Z",
      fill: props.color || '#212529'
    }, null, 8, _hoisted_3)
  ]))
}
}

})